import { isDictionaryLike } from ".";

export interface ISimulatorRunModesResponse {
  run_modes: Array<{
    id: string;
    display_name: string;
  }>;
}

/**
 * Type-guard for checking if an input is a valid
 * ISimulatorRunModesResponse
 * @param candidate unknown input to check
 */
export const isSimulatorRunModesResponse = (
  candidate: unknown
): candidate is ISimulatorRunModesResponse => {
  if (!candidate) {
    return false;
  } else if (!isDictionaryLike(candidate)) {
    return false;
  } else if (!Array.isArray(candidate.run_modes)) {
    return false;
  } else if (candidate.run_modes.length === 0) {
    return true;
  }

  for (const elementAny of candidate.run_modes) {
    const element: unknown = elementAny; // convert to unknown
    if (!isDictionaryLike(element)) {
      return false;
    } else if (typeof element.id !== "string") {
      return false;
    } else if (typeof element.display_name !== "string") {
      return false;
    }
  }

  return true;
};
